<!--当广告位是视频信息流时的素材组件-->
<template>
  <div class="uploadImg uploadVideo">
    <div class="sig_pic">
      <span
        class="addMat"
        :class="{disableCus:pageType==='read'}"
        v-if="adSpace==='6'||adSpace==='2'"
        @click="addMat(pageType==='read')"
      >增加素材</span>
      <div class="materialBox" v-for="(item,index) in videoMaterial">
        <p class="mat_item clearfix" v-if="adSpace==='6'||adSpace==='2'">
          <label>广告标题</label>
          <input
            type="text"
            class="addTitle"
            v-model="item.title"
            @keyup="titleLen(index)"
            :maxlength="35"
            @blur="titleBlur(index)"
          >
          <span class="wordLimit" v-if="titOver">输入的内容不能超过35个字符！</span>
        </p>
        <p class="mat_item" v-if="adSpace==='6'||adSpace==='2'||(adSpace==='1'&&index===0)">
          <label>素材上传</label>
          <span class="uploadBtn">
            上传素材
            <input
              type="file"
              accept="video/mp4"
              @change="onFileChange($event,index,'add')"
              ref="fileBox"
              :disabled="pageType==='read'"
              :class="{disableCus:pageType==='read'}"
              :multiple="adSpace==='1'"
            >
          </span>
          <span class="typeLimit">只能上传MP4格式视频,大小不超过{{adSpace==='1'?'5M':'50M'}}</span>
        </p>
        <label class="mt30" v-if="adSpace==='6'||adSpace==='2'||(adSpace==='1'&&index===0)">素材预览</label>
        <div class="picBox clearfix" :class="{ml137: adSpace==='1'&&index>0}">
          <span
            class="del_mar"
            v-if="(((adSpace==='6'||adSpace==='2')&&index>0)||adSpace==='1')&&pageType!=='read'"
            @click="deleteMat(index,item['group'])"
          >删除素材</span>
          <p class="title1" v-if="adSpace==='6'||adSpace==='2'">{{item.title}}</p>
          <p class="picInfo fl w469">
            <a href="javascript:;" target="_blank" class="bigImg videoItem">
              <!--<el-progress type="circle" :percentage="progress"></el-progress>-->
              <video :src="item.path" controls></video>
              <span class="shadow" :class="{bg:item.code==='0',noBg:item.code==='1'}">
                <b :class="{redWord: item.code==='0'}">
                  <i v-if="item.initState" class="icon iconfont icon-video"></i>
                  {{item.initState?'':(item.code==='0'?'尺寸错误！':'')}}
                </b>
                <i
                  class="icon iconfont matchIcon"
                  :class="{'icon-wrong':item.code==='0','icon-right':item.code==='1'&&!item.initState}"
                ></i>
              </span>
            </a>
            <span class="replace" v-if="adSpace==='6'||adSpace==='2'">
              替换
              <input
                type="file"
                @change="onFileChange($event,index,index,item['id'])"
                ref="inputFileRep"
              >
            </span>
            <span class="pic_size displayBlock">{{item.size}}</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  props: {
    materialSize: { // 素材尺寸
      type: Array,
      defalut: []
    },
    adSpace: { // 2 开屏广告  6 频道信息流广告, 视频信息流广告
      type: String
    },
    clearMaterial: {
      type: Boolean,
      default: false
    },
    advertiseId: {
      type: String,
      default: ''
    },
    pageType: {
      type: String,
      default: ''
    },
    matGroupData: {
      type: Array
    }
  },
  data () {
    return {
      titOver: false, // 标题输入框失去焦点时   控制标题长度
      videoMaterial: [{ title: '', path: '', size: '', code: '', sizeid: '', initState: 1, play_time: '' }],
      uploadDisable: false,
      progress: 0
    };
  },
  computed: {
    ...mapGetters({
      uploadMaterial: 'uploadMaterial',
      uploadedVideo: 'uploadedVideo',
      delComMaterial: 'delComMaterial',
      delMatGroup: 'delMatGroup'
    })
  },
  created () {
    if (this.matGroupData.length > 0) {
      this.videoMaterial = this.matGroupData;
    }
  },
  methods: {
    // 上传视频----------------------------------start
    onFileChange (e, matIndex, add, id) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImage(files, matIndex, add, id);
    },
    // 过滤出满足条件的图片
    imageValid (file, imgType, imgSize1) {
      let fileArr = [];
      let arr = [];
      let typeArrNo = [];
      let meetArr = [];
      fileArr.slice.call(file).forEach((v, i) => {
        if (v.type !== 'video/mp4') {
          typeArrNo.push(v.name);
        } else {
          arr.push({ name: v.name, type: v.type, size: v.size });
        }
      });
      file = fileArr.slice.call(file).filter((value) => {
        return typeArrNo.indexOf(value.name) === -1;
      });
      arr.forEach((v, i) => {
        if (v.type === 'video/mp4') {
          if (this.adSpace === '1' && v.size >= 5242880) {
            meetArr.push(v.name);
          }
          if ((this.adSpace === '6' || this.adSpace === '2') && v.size >= 52428800) {
            meetArr.push(v.name);
          }
        }
      });
      if (typeArrNo.length > 0 || meetArr.length > 0) {
        let tips = '';
        if (typeArrNo.length > 0) tips += typeArrNo.join(',') + '的格式不正确！';
        if (meetArr.length > 0) tips = '素材大小有误，请修改！';
        this.$confirm(tips, '提示', {
          confirmButtonText: '确定',
          showCancelButton: false,
          callback: () => {
          },
          type: 'error'
        });
      }
      file = fileArr.slice.call(file).filter((value) => {
        return meetArr.indexOf(value.name) === -1;
      });
      return file;
    },
    createImage (file, matIndex, add, id) {
      file = this.imageValid(file);
      if (typeof FileReader === 'undefined') {
        this.$message({
          showClose: true,
          message: '您的浏览器不支持图片上传，请升级您的浏览器！',
          type: 'warning'
        });
        return false;
      }
      let vm = this;
      let leng = file.length;
      let a = 0;
      let addIndex = 0;
      let matFile = vm.videoMaterial;
      vm.videos = [];
      for (let i = 0; i < leng; i++) {
        let reader = new FileReader();
        reader.onload = function (e) {
          a++;
          vm.videos.push(e.target.result);
          // this.progress = Math.round(e.loaded * 100 / e.total)
          if (a === leng) {
            vm.$store.dispatch('getUploadedVideo', {
              file: vm.videos,
              size: vm.materialSize
            }).then(() => {
              if (vm.uploadedVideo.success === 1) {
                vm.uploadedVideo.data.forEach((v, i) => {
                  for (let j = 0; j < matFile.length; j++) {
                    if (!matFile[j] || matFile[j].path === '') {
                      addIndex = j;
                      break;
                    }
                  }

                  if (vm.adSpace === '1') {
                    if (matFile[0].path === '') {
                      addIndex = 0;
                    } else {
                      addIndex = matFile.length;
                    }
                    // 开屏广告
                    matFile.splice(addIndex, 1, {
                      path: v.path,
                      size: v.size,
                      code: v.code,
                      sizeid: v.sizeid,
                      initState: 0,
                      play_time: v.play_time
                    });
                  } else if (vm.adSpace === '6' || vm.adSpace === '2') {
                    // 信息流广告
                    matFile.splice(add === 'add' ? addIndex : add, 1, {
                      title: matFile[matIndex].title,
                      path: v.path,
                      size: v.size,
                      code: v.code,
                      sizeid: v.sizeid,
                      initState: 0,
                      play_time: v.paly_time
                    });
                  }
                });
              }
            });
            vm.clearInputFile();
          }
        };
        reader.readAsDataURL(file[i]);
      }
    },
    clearInputFile () {
      let inputFile = this.$refs.fileBox;
      inputFile.value = '';
      //  inputFile.outerHTML = inputFile.outerHTML
    },
    // 上传视频----------------------------------end
    sendData () {
      this.$emit('uploadedMaterial', this.pageMaterial.data);
    },
    addMat (disableCode) {
      if (disableCode) return;
      let flag = this.validInfo();
      if (flag) return;
      let currMaterial = this.videoMaterial;
      if (currMaterial.length > 4) {
        this.$message({
          showClose: true,
          message: '最多上传5组素材！',
          type: 'warning'
        });
        return false;
      }
      currMaterial.push({
        title: '', path: '', size: '', code: '', initState: 1, play_time: ''
      });
    },
    // 验证弹窗
    validBox (info) {
      this.$confirm(info, '提示', {
        confirmButtonText: '确定',
        showCancelButton: false,
        type: 'warning'
      });
    },
    validInfo () {
      /*
           * 最后一组素材的验证
           * 标题不能为空
           * 图片个数为1或为3
           * 尺寸不匹配的 重新上传活替换
           * */
      let currMaterial = this.videoMaterial;
      let lastMaterial = currMaterial[currMaterial.length - 1];
      let noMatch;
      let noImg;
      if (lastMaterial.title === '') {
        this.validBox('请输入标题!');
        return true;
      }
      noImg = lastMaterial.path === '';
      if (noImg) {
        this.validBox('请上传素材!');
        return true;
      }
      noMatch = lastMaterial.code === '0';
      if (noMatch) {
        this.validBox('请替换尺寸不匹配的素材!');
        return true;
      }
    },
    // 标题字符长度限制
    titleLen (index) {
      if (this.videoMaterial[index].title.length >= 35) {
        this.titOver = true;
      } else {
        this.titOver = false;
      }
    },
    //
    titleBlur (index) {
      let mat = this.videoMaterial;
      mat.splice(index, 1, mat[index]);
    },
    // 删除素材组
    deleteMat (index, group) {
      if (!group) {
        this.videoMaterial.splice(index, 1);
      } else {
        this.$confirm('是否永久删除？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$store.dispatch('getDelMatGroupCode', { aid: this.advertiseId, group: group }).then(() => {
            if (this.delMatGroup.success === 1) {
              this.videoMaterial.splice(index, 1);
              this.$message({
                showClose: true,
                message: '已删除！',
                type: 'success'
              });
            } else {
              this.$message({
                showClose: true,
                message: '删除失败！',
                type: 'error'
              });
            }
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      }
    },
    // 清空素材
    clearMat () {
      let materials = this.videoMaterial;
      materials.splice(0, materials.length, {
        title: '', path: '', size: '', code: '', initState: 1, play_time: ''
      });
    }
  },
  watch: {
    clearMaterial () {
      // this.clearMat()
    },
    // 验证用户是否上传正确素材
    validMaterial () {
      let flag = this.validInfo();
      if (flag) {

      }
    },
    videoMaterial () {
      this.$emit('videoMaterialChange', this.videoMaterial);
    },
    matGroupData () {
      this.videoMaterial = this.matGroupData;
    }
  }
};
</script>

<style lang="scss" rel="stylesheet/scss">
.uploadType1 {
  .imgBox {
    margin-left: 0 !important;
  }
}
.ml137 {
  margin-left: 137px;
}
</style>
